import { Configuration } from "@/types";

type AnalyticsConfiguration = Partial<Pick<Configuration, "analytics">> | null;

export default function isAnalyticsEnabled(configuration?: AnalyticsConfiguration): boolean {
    return Boolean(configuration?.analytics);
}
